import React from 'react';
import AccountDropdown from '../AccountDropdown/AccountDropdown';
import './TopNav.css';

const TopNav = ({ setIsLoggedIn }) => {
    return (
        <div className="TopNav">
            <h1 className="sungate-logo">Sungate Systems</h1>
            <AccountDropdown setIsLoggedIn={setIsLoggedIn}/>
        </div>
    );
};

export default TopNav;
